// How every search box in the app matches, so the same person is found
// however the desk types them: "camille ashworth", "Ashworth Camille",
// "  camille ", "José" or "jose", "(630) 235-1447" or "630235".
//
//   - case, accents and extra spaces do not matter
//   - every word typed has to appear somewhere in the record, in any field
//     and any order, which is what makes a full name work (each field on
//     its own never contains "camille ashworth")
//   - a word made of digits also matches phone numbers digit for digit, so
//     punctuation in either the query or the stored number does not matter

export const normalizeText = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

const digitsOnly = (value) => String(value ?? "").replace(/\D/g, "");
const PHONEISH = /^[\d\s().+-]+$/;

export const searchWords = (query) => normalizeText(query).split(" ").filter(Boolean);

export const matchesSearch = (query, fields) => {
  const words = searchWords(query);
  if (!words.length) return true;
  const list = (fields || []).filter((f) => f !== null && f !== undefined && f !== "");
  const text = list.map(normalizeText).join("  ");
  const digits = list.map(digitsOnly).filter(Boolean).join(" ");
  return words.every((word) => {
    if (text.includes(word)) return true;
    const d = digitsOnly(word);
    return PHONEISH.test(word) && d.length >= 3 && digits.includes(d);
  });
};

// The fields a contact is found by: their own name, email and phone, and
// the parent's, for the kids' studios that book through a parent.
export const contactSearchFields = (c = {}) => [
  c.first_name,
  c.last_name,
  c.email,
  c.phone,
  c.parent_first_name,
  c.parent_last_name,
  c.parent_email,
  c.parent_phone,
];
